import { render, staticRenderFns } from "./ReportApprove.vue?vue&type=template&id=384c7453&scoped=true&"
import script from "./ReportApprove.vue?vue&type=script&lang=js&"
export * from "./ReportApprove.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384c7453",
  null
  
)

export default component.exports